'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmailish = require('./isEmailish');

var _isEmailish2 = _interopRequireDefault(_isEmailish);

var _hasProtocol = require('./hasProtocol');

var _hasProtocol2 = _interopRequireDefault(_hasProtocol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (link) {
  var protocol = arguments.length <= 1 || arguments[1] === undefined ? 'http://' : arguments[1];

  if ((0, _hasProtocol2.default)(link)) {
    return link;
  }

  if ((0, _isEmailish2.default)(link)) {
    return 'mailto:' + link;
  }

  return '' + protocol + link;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/withProtocol.js
 ** module id = 63
 ** module chunks = 0
 **/